module.exports = __webpack_public_path__ + "static/media/SWSCRC6-13.9853c6c4.mp3";